import type { Capability } from '@taler/api-client'

/** No dedicated target capability exists; a target is a financial record like a loan or a contact. */
export function canViewTargets(can: (capability: Capability) => boolean): boolean {
  return can('RECORDS_MANAGE')
}
